import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinBlurEvent, mixinFocusEvent, mixinChangeEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/range/range';

class FadvRangeComponent extends mixinBlurEvent(mixinFocusEvent(mixinChangeEvent(mixinFormControl(FadvBaseComponent)))) {
    constructor(el) {
        super(el);
        this.step = 1;
        this.tooltip = 'none';
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => (this.value = value));
        this.registerSubscription(this.changed, () => this.reportChange(this.elementRef.nativeElement.value));
        this.registerSubscription(this.blurred, () => this.onTouched());
    }
    tooltipFormatter(value) {
        var _a, _b;
        (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.tooltipFormatter(value);
    }
}
FadvRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvRangeComponent, selector: "fadv-range", inputs: { value: "value", disabled: "disabled", helpText: "helpText", invalid: "invalid", label: "label", max: "max", min: "min", name: "name", step: "step", tooltip: "tooltip" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed" }, providers: [createFormControlProvider(FadvRangeComponent)], usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvRangeComponent.prototype, "helpText", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "max", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "min", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "step", void 0);
__decorate([
    Forward()
], FadvRangeComponent.prototype, "tooltip", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-range',
                    template: '',
                    providers: [createFormControlProvider(FadvRangeComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { helpText: [{
                type: Input
            }], invalid: [{
                type: Input
            }], label: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], name: [{
                type: Input
            }], step: [{
                type: Input
            }], tooltip: [{
                type: Input
            }] } });

class FadvRangeModule {
}
FadvRangeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvRangeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeModule, declarations: [FadvRangeComponent], imports: [FadvCommonModule], exports: [FadvRangeComponent] });
FadvRangeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRangeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvRangeComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvRangeComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvRangeComponent, FadvRangeModule };
